export const ProductMonthsCategoryCode = 300
export const ProductMonthsCategory = 'indikator-produkte-300'
